import Analytics from '@hh.ru/analytics-js';
import { useSelector, TranslatedComponent, translation } from '@hh.ru/front-static-app';
import { Button, Card, VSpacing } from '@hh.ru/magritte-ui';
import { SPALink } from '@hh.ru/redux-spa-middleware';
import { CompensationMode, SalaryRange } from '@hh.ru/types-hh-microcore';

import SalaryMarketRangeChart from 'src/components/SalaryMarketRangeChart';
import SalaryAdviceTooltip from 'src/components/VacancyAdvicesModal/SalaryAdviceTooltip';
import { SALARY_VACANCY_ADVICES } from 'src/components/VacancyAdvicesModal/constants';
import { getLinkUrl } from 'src/components/VacancyAdvicesModal/utils';

import SalaryRangeCardHeading from 'src/components/SalaryMarketRangeCard/SalaryRangeCardHeading';
import { NO_SALARY_ADVICE } from 'src/components/SalaryMarketRangeCard/constants';

const TrlKeys = {
    link: 'employer.vacancy.tab.stat.salaryChart.link.text',
};

const SalaryMarketRangeCard: TranslatedComponent = ({ trls }) => {
    const { compensation, marketRange, salaryRange, advices, vacancyId } = useSelector(
        (state) => state.salaryMarketRangeData
    );
    const advice = advices.find((item) => SALARY_VACANCY_ADVICES.includes(item)) ?? NO_SALARY_ADVICE;
    const hasSalaryAdvice = advice !== NO_SALARY_ADVICE;

    const hasMarketRange = marketRange && Object.values(marketRange).every(Boolean);
    const hasSalaryRange = salaryRange && salaryRange !== SalaryRange.Undefined;
    // temp_start-PORTFOLIO-37087 Канвак не умеет не в месячную зарплату
    const canShowSalaryChart =
        ('noCompensation' in compensation || compensation?.mode === CompensationMode.Month) &&
        // temp_end-PORTFOLIO-37087
        hasMarketRange &&
        hasSalaryRange;

    const onButtonClick = () => {
        Analytics.sendHHEventButtonClick('vacancy_view_stat_tab_salary_chart_link', { vacancyId });
    };

    const onChartClick = () => {
        Analytics.sendHHEventButtonClick('vacancy_view_stat_tab_salary_chart', { vacancyId });
    };

    if (!canShowSalaryChart) {
        return null;
    }

    return (
        <>
            <Card stretched padding={12}>
                <SalaryRangeCardHeading advice={advice} marketRange={marketRange} salaryRange={salaryRange} />
                <VSpacing default={24} xs={20} />
                <SalaryMarketRangeChart
                    compensation={compensation}
                    marketRange={marketRange}
                    salaryRange={salaryRange}
                    infoComponent={
                        <SalaryAdviceTooltip
                            vacancyId={vacancyId}
                            analyticEventName="vacancy_view_stat_tab_salary_chart_tooltip"
                        />
                    }
                    onChartClick={onChartClick}
                    overrideColor={!hasSalaryAdvice}
                />
            </Card>
            {hasSalaryAdvice && (
                <>
                    <VSpacing default={12} />
                    <Button
                        stretched
                        Element={SPALink}
                        target="_blank"
                        to={getLinkUrl(advice, vacancyId)}
                        mode="secondary"
                        style="accent"
                        onClick={onButtonClick}
                        data-qa="tab-stat-edit-salary"
                    >
                        {trls[TrlKeys.link]}
                    </Button>
                </>
            )}
        </>
    );
};

export default translation(SalaryMarketRangeCard);
